import type { Supplier } from '../types/supplier';

export const supplierRowKey = (supplier: Supplier): string => String(supplier.id);

export interface SupplierTotals {
  count: number;
  balance: number;
}

export const computeSupplierTotals = (rows: Supplier[]): SupplierTotals => {
  let balance = 0;
  for (const row of rows) {
    balance += parseFloat(row.balance) || 0;
  }
  return {
    count: rows.length,
    balance,
  };
};
